var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3a1 1 0 00-1 1v5H4a1 1 0 000 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5V4a1 1 0 00-1-1z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDNDOS40NDc3MiAzIDkgMy40NDc3MiA5IDRWOUg0QzMuNDQ3NzIgOSAzIDkuNDQ3NzIgMyAxMEMzIDEwLjU1MjMgMy40NDc3MiAxMSA0IDExSDlWMTZDOSAxNi41NTIzIDkuNDQ3NzIgMTcgMTAgMTdDMTAuNTUyMyAxNyAxMSAxNi41NTIzIDExIDE2VjExSDE2QzE2LjU1MjMgMTEgMTcgMTAuNTUyMyAxNyAxMEMxNyA5LjQ0NzcyIDE2LjU1MjMgOSAxNiA5SDExVjRDMTEgMy40NDc3MiAxMC41NTIzIDMgMTAgM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgAdd20 as ReactComponent };